<script setup lang="ts">
import { IconHelp, IconSquareX } from "@tabler/icons-vue";
// @ts-ignore
import MarkdownIt from "markdown-it";
import { NIcon } from "naive-ui";
import {
	PopoverRoot as Popover,
	PopoverArrow,
	PopoverClose,
	PopoverTrigger,
} from "reka-ui";
import { computed, onMounted } from "vue";
import PopoverContent from "@/components/ui/popover/PopoverContent.vue";
import { useTooltipStore } from "@/stores/tooltip";

const {
	fileName,
	showText = true,
	iconSize = 25,
} = defineProps<{
	fileName: string;
	showText?: boolean;
	iconSize?: number;
}>();

const tooltipStore = useTooltipStore();

const fileContent = computed(() => tooltipStore.fileContent[fileName]);
const isHighlighted = computed(() => tooltipStore.isHighlighted[fileName]);

onMounted(async () => {
	!fileContent.value && (await tooltipStore.fetchContent(fileName));
});
</script>
<template>
	<Popover
		@update:open="
			(open) => !open && tooltipStore.updateTooltipMetadata(fileName)
		"
	>
		<PopoverTrigger as-child>
			<button
				class="flex items-center gap-1 cursor-pointer"
				:class="{ 'dark:text-yellow-300 text-orange-400': isHighlighted }"
			>
				<NIcon :size="iconSize">
					<IconHelp />
				</NIcon>
				<span v-if="showText" class="underline"> Help & Guidelines </span>
			</button>
		</PopoverTrigger>
		<PopoverContent
			align="end"
			class="PopoverContent"
			update-position-strategy="always"
			:avoidCollisions="true"
			:side-offset="12"
			positionStrategy="absolute"
			sticky="always"
			:class="{
				'border-1 dark:border-yellow-300 border-orange-400': isHighlighted,
			}"
		>
			<div v-html="fileContent"></div>
			<PopoverClose
				class="rounded-full h-[25px] w-[25px] inline-flex items-center justify-center text-grass11 absolute top-[8px] right-[17px] outline-none cursor-pointer"
				aria-label="Close"
			>
				<IconSquareX />
			</PopoverClose>
			<PopoverArrow
				:height="20"
				:width="20"
				class="fill-card stroke-muted-foreground/30 -translate-y-[1px]"
				:class="{ 'dark:stroke-yellow-300 stroke-orange-400': isHighlighted }"
				:rounded="true"
			/>
		</PopoverContent>
	</Popover>
</template>
<style>
@reference "../../style.css";

.PopoverContent {
	width: 40vw;
	max-width: 100vw;
	max-height: 90vh;
	overflow: auto;
	@apply prose dark:prose-invert prose-sm lg:prose-base prose-a:text-blue-600;
}
</style>
